export const LOCALES = {
  de: "de-DE",
  en: "en-GB",
};

export const localeForLanguage = (language) => {
  if (!Object.prototype.hasOwnProperty.call(LOCALES, language)) {
    throw new Error(`Unsupported offer language: ${language}`);
  }
  return LOCALES[language];
};

export const formatNumber = (value, language, options = {}) => new Intl.NumberFormat(
  localeForLanguage(language),
  options,
).format(Number(value));

export const formatCurrency = (value, language) => new Intl.NumberFormat(
  localeForLanguage(language),
  {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
).format(Number(value));

export const formatDate = (value, language, options = {}) => {
  if (!value) return value;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(localeForLanguage(language), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...options,
  }).format(date);
};

const strictGermanDate = /^(\d{2})\.(\d{2})\.(\d{4})$/;

const parseGermanDate = (value) => {
  const match = value.match(strictGermanDate);
  if (!match) return null;
  const date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  return date.getFullYear() === Number(match[3])
    && date.getMonth() === Number(match[2]) - 1
    && date.getDate() === Number(match[1])
    ? date
    : null;
};

export const formatStrictCombitDate = (value, language) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  const singleDate = parseGermanDate(trimmed);
  if (singleDate) return formatDate(singleDate, language);

  const range = trimmed.match(/^(\d{2}\.\d{2}\.\d{4})\s+-\s+(\d{2}\.\d{2}\.\d{4})$/);
  if (!range) return value;
  const start = parseGermanDate(range[1]);
  const end = parseGermanDate(range[2]);
  return start && end
    ? `${formatDate(start, language)} - ${formatDate(end, language)}`
    : value;
};

export const formatDuration = (
  value,
  durationPerDay,
  numberOfExecutions,
  language,
  translateChoice,
) => {
  const unit = durationPerDay && Number(durationPerDay) < 7 ? "common.halfDay" : "common.day";
  const duration = `${formatNumber(value, language, { maximumFractionDigits: 20 })} ${translateChoice(unit, Number(value))}`;
  return Number(numberOfExecutions) > 1 ? `${numberOfExecutions} × ${duration}` : duration;
};

export const formatTimeRange = (startTime, durationHours, translate) => {
  const start = startTime || "09:00";
  const duration = durationHours ? Number(durationHours) : 7;
  const [hours, minutes] = start.split(":").map(Number);
  const normalizedStart = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  const totalMinutes = hours * 60 + minutes + duration * 60;
  const end = `${String(Math.floor(totalMinutes / 60) % 24).padStart(2, "0")}:${String(totalMinutes % 60).padStart(2, "0")}`;
  return translate("seminarDetails.timeRange", { start: normalizedStart, end });
};
